export function normalizeLatLng(latlng) {
	if (!latlng[0] || !latlng[1]) return '';
	let LAT = latlng && Number(latlng[0])?.toFixed(4);
	let LNG = latlng && Number(latlng[1])?.toFixed(4);
	LAT > 0 ? LAT+='N' : LAT=Math.abs(LAT)+'S';
	LNG > 0 ? LNG+='E' : LNG=Math.abs(LNG)+'W';
	return `${LAT} , ${LNG}`;
}